import { Component, OnInit, HostListener } from '@angular/core';
import { NavbarComponent } from '../../components/navbar/navbar.component';
import { FooterComponent } from '../../components/footer/footer.component';
import { GaleryComponent } from '../../components/galery/galery.component';
import { ActivatedRoute, Router } from '@angular/router';
import { HostingService } from '../../services/hosting.service';
import { SearchService } from '../../services/search.service';
import { Hosting } from '../../models/HostingModel';
import { FormsModule} from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { CommonModule } from '@angular/common';
import { ReservationService } from '../../services/reservation.service';
import { AuthService } from '../../services/auth.service';
import { TokenStorageService } from '../../services/token-storage.service';

// Definir la interfaz AdditionalService
interface AdditionalService {
  id: string;
  service: string;
  cost: number;
  status: string;
  selected: boolean;
}

// Definir la interfaz para servicios adicionales en la reserva
interface ReservationAdditionalService {
  serviceId: string;
  name: string;
  cost: number;
  description: string;
}

// Definir la interfaz para el objeto de reserva
interface ReservationData {
  checkInDate: string;
  checkOutDate: string;
  hotelId: string;
  roomId: string;
  roomCost: number;
  numAdults: number;
  numChildren: number;
  numInfants: number;
  additionalServices: ReservationAdditionalService[];
}

// Definir la interfaz de state
interface NavigationState {
  checkInDate: string | Date;
  checkOutDate: string | Date;
  numAdults: number,
  numChildren: number,
  numInfants: number,
  selectedServices: string[];
}
//definir la interfaz de services
interface Services{
  name: string
}

//Definir la interfaz de reviews
interface Reviews{
  rating: number,
  review_id: string,
  created_at: string | Date;
  comment: string,
  customer_id: string,
  updated_at: string | Date;
}

@Component({
  selector: 'app-hosting-detail',
  imports: [
    NavbarComponent,
    FooterComponent,
    GaleryComponent,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    FormsModule,
    CommonModule,
    MatProgressBarModule,
  ],
  templateUrl: './hosting-detail.component.html',
  styleUrl: './hosting-detail.component.css',

})
export class HostingDetailComponent implements OnInit{
  // Forzar modo usuario en esta página
  readonly modoUser = true;
  hosting: Hosting | null = null;

   // Fechas de entrada y salida
  checkInDate!: Date;
  checkOutDate!: Date;
  // Variables para manejar validaciones de fechas
  occupiedPeriods: { start: Date, end: Date }[] = [];
  isLoadingDates = false;
  // Lista de servicios incluidos
 services: Services[] = [];

   // Lista de servicios adicionales
  additionalServices: AdditionalService[] = [];

  // Lista de servicios seleccionados
  selectedServices: AdditionalService[] = [];

  // Precio subtotal costos adicionales
  servicesSubtotal: number = 0;

  // Número de noches
  numberOfNights: number = 0;

  // Subtotal de la habitación
  roomSubtotal: number = 0;

  // Total general (habitación + servicios adicionales)
  get total(): number {
    return this.servicesSubtotal + this.roomSubtotal;
  }

  // Variable para detectar pantallas pequeñas
  isSmallScreen: boolean = false;

  // Variables para el selector de huéspedes
  adults: number = 1;
  childrenOver2: number = 0;
  babiesUnder2: number = 0;
  pets: number = 0;

  // Control del menú desplegable de huéspedes
  isGuestMenuOpen: boolean = false;

  // Variables adicionales para compatibilidad con formulario estilo hostinglist
  showGuestsDropdown: boolean = false;

  // Variables para manejar fechas como strings (compatibilidad con hostinglist)
  checkInDateStr: string = '';
  checkOutDateStr: string = '';

  //Lista de reviews
  reviews: Reviews[]=[]

  // Variables para el modal de reviews
  showAllReviews = false;
  visibleReviewsLimit = 2;
  modalOpen = false;

  //variables para manejar autenticación
  isAuthenticated = false;
  userId: string | null = null;
  accessToken: string | null = null;

  // Variables para datos de búsqueda
  hasSearchData = false;
  searchData: any = null;

  // Variables para manejar estado de errores del backend
  backendStatus = {
    authServiceAvailable: true,
    reservationServiceAvailable: true,
    lastCheck: new Date()
  };

  constructor(
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly hostingService: HostingService,
    private readonly reservationService: ReservationService,
    private readonly authService: AuthService,
    private readonly searchService: SearchService,
    private readonly tokenStorage: TokenStorageService
  ) {

  }

  ngOnInit(): void {
    // Cargar datos de búsqueda del servicio
    this.loadSearchData();

    const id = this.route.snapshot.paramMap.get('id');
    if (!id) {
      console.error("ID no encontrado en la URL");
      return;
    }

    // Intentar obtener los datos del carrito desde history.state
    let state = history.state as {
      checkIn: string,
      checkOut: string,
      adults: number,
      children: number,
      infants: number,
      services: string[],
      hostingId: string
    };

    // Si history.state no tiene la información, se puede intentar cargar desde localStorage
    if (!state?.hostingId) {
      const tempData = localStorage.getItem('tempReservation');
      if (tempData) {
        state = JSON.parse(tempData);
        //Eliminar localStorage si ya se usó
        localStorage.removeItem('tempReservation');
      }
    }

    // Ahora se carga el alojamiento
    this.hostingService.getHosting(id).subscribe(data => {
      this.hosting = data;

      // Actualizar información del hotel en SearchService
      this.searchService.updateHotelInfo(
        this.hosting.id,
        this.hosting.name,
  Number(this.hosting.room?.price_per_night ?? 0)
      );

      // Mapeo de servicios adicionales
      this.additionalServices = this.hosting.additional.map((service: any) => ({
        id: service.additional_id,
        service: service.service,
        cost: service.cost,
        status: service.status,
        selected: false,
      }));
      // Mapeo de servicios
      this.services = this.hosting.service.name.map((service: any) => ({
        name: service,
      }));

      // Mapear las reseñas desde los datos del alojamiento
     this.reviews = this.hosting.review.reviews.map((review: any) => ({
      rating: review.rating,
      review_id: review.review_id,
      created_at: review.created_at,
      comment: review.comment,
      customer_id: review.customer_id,
      updated_at: review.updated_at,
    }));

      // Restaurar datos del carrito si existen y corresponden al alojamiento
      if (state && state.hostingId === id) {
        this.checkInDate = new Date(state.checkIn);
        this.checkOutDate = new Date(state.checkOut);
        this.adults = state.adults;
        this.childrenOver2 = state.children;
        this.babiesUnder2 = state.infants;

        // Restaurar servicios seleccionados
        this.additionalServices.forEach(service => {
          if (state.services.includes(service.id)) {
            service.selected = true;
            this.selectedServices.push(service);
            this.servicesSubtotal += service.cost;
          }
        });
        this.calculateNumberOfNights();
        // ✅ AGREGAR: Recalcular subtotal después de restaurar datos
        this.calculateRoomSubtotal();
      }

      // ✅ AGREGAR: Calcular subtotal inicial cuando se carga el hosting
      this.calculateRoomSubtotal();
    });

    // Solo cargar fechas ocupadas SI el usuario está autenticado y tiene tokens
    // Ya no lo hacemos automáticamente para evitar llamadas innecesarias

    // Otras inicializaciones básicas
    this.checkScreenSize();

    // ✅ OPCIONAL: Verificación silenciosa de autenticación solo para mejorar UX
    // Esto no hace llamadas al servidor, solo verifica tokens locales
    this.initializeSilentAuth();

    // ⚠️ REMOVIDO: Ya no llamamos automáticamente loadOccupiedDates() ni checkAuthentication()
    // Esto se hará solo cuando el usuario haga clic en "Reservar"
  }

  /**
   * Inicialización silenciosa de autenticación - solo verifica tokens locales
   * No hace llamadas al servidor para evitar las llamadas innecesarias
   */
  private async initializeSilentAuth() {
    try {
      // Solo verificar si hay token válido localmente, sin llamadas al servidor
      const hasValidToken = await this.authService.isAuthenticated();
      this.isAuthenticated = hasValidToken;

      if (hasValidToken) {
        this.accessToken = this.tokenStorage.getAccessToken();
        // NO llamamos a getUser() aquí para evitar llamadas al servidor
        // Esto se hará solo cuando sea necesario (al hacer clic en reservar)
      }
    } catch (error) {
      // Error silencioso durante inicialización, resetear estado de autenticación
      this.resetAuthenticationState();
    }
  }


// Función para manejar la selección de servicios
 toggleService(service: AdditionalService) {
   service.selected = !service.selected;

   if (service.selected) {
     this.selectedServices.push(service); // Añadir al carrito
     this.servicesSubtotal+= service.cost; // Sumar al precio total
   } else {
     this.selectedServices = this.selectedServices.filter(s => s.id !== service.id); // Eliminar del carrito
     this.servicesSubtotal-= service.cost; // Restar del precio total
   }
 }
 // Método mejorado para cargar fechas ocupadas solo cuando sea necesario
 loadOccupiedDates(hotelId: string, silent: boolean = true): void {
  this.isLoadingDates = true;
  // Siempre modo usuario en esta página
  const user = this.tokenStorage.getUser();
  const userId = user?.id || user?.attributes?.sub;
  console.log('[DEBUG] loadOccupiedDates - userId:', userId, 'modoUser:', this.modoUser);
  this.reservationService.getUserReservations(this.accessToken || '', userId, false).subscribe({
    next: (response) => {
      if (!silent) {
        console.log('✅ Fechas ocupadas del usuario:', response);
      }
      if (response?.reservations && Array.isArray(response.reservations)) {
        this.occupiedPeriods = response.reservations.map((reservation: any) => ({
          start: new Date(reservation.check_in_date || reservation.checkInDate),
          end: new Date(reservation.check_out_date || reservation.checkOutDate)
        }));
      } else {
        this.occupiedPeriods = [];
      }
      this.isLoadingDates = false;
    },
    error: (err) => {
      if (!silent) {
        console.warn('⚠️ Error cargando fechas ocupadas (usuario):', err);
      }
      this.isLoadingDates = false;
      this.occupiedPeriods = [];
    }
  });
}

// Filtro para el datepicker
dateFilter = (date: Date | null): boolean => {
  if (!date) return false;

  // 1. Bloquear fechas pasadas
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  if (date < today) return false;

  // 2. Bloquear fechas en periodos ocupados
  const dateTime = date.getTime();
  for (const period of this.occupiedPeriods) {
    if (dateTime >= period.start.getTime() && dateTime <= period.end.getTime()) {
      return false;
    }
  }

  return true;
};
 // Método para manejar cambios en la fecha de entrada
 onCheckInDateChange(date: Date) {
  this.checkInDate = date;
  this.validateDateRange();
  this.calculateNumberOfNights();
}

// Método para manejar cambios en la fecha de salida
onCheckOutDateChange(date: Date) {
  this.checkOutDate = date;
  this.validateDateRange();
  this.calculateNumberOfNights();
}
// Validación del rango de fechas
validateDateRange(): void {
  if (this.checkInDate && this.checkOutDate && this.checkOutDate <= this.checkInDate) {
    // Resetear fecha de salida si es inválida
    this.checkOutDate = new Date(this.checkInDate);
    this.checkOutDate.setDate(this.checkInDate.getDate() + 1);
  }
}
 // Función para calcular el número de noches
 calculateNumberOfNights() {
  if (this.checkInDate && this.checkOutDate && this.checkOutDate > this.checkInDate) {
    const timeDifference = this.checkOutDate.getTime() - this.checkInDate.getTime();
    this.numberOfNights = Math.ceil(timeDifference / (1000 * 3600 * 24));
    this.calculateRoomSubtotal();
  } else {
    this.numberOfNights = 0; // Reiniciar el número de noches si las fechas no son válidas
    this.calculateRoomSubtotal();
  }
}

  // Método para calcular el subtotal de la habitación
  calculateRoomSubtotal() {
    console.log('🔢 Calculando roomSubtotal...');
    console.log('📊 numberOfNights:', this.numberOfNights);
    console.log('🏨 hosting disponible:', !!this.hosting);

    if (this.hosting) {
  console.log('💰 precio por noche desde hosting:', this.hosting.room?.price_per_night);
  this.roomSubtotal = this.numberOfNights * Number(this.hosting.room?.price_per_night ?? 0);
      console.log('✅ roomSubtotal calculado desde hosting:', this.roomSubtotal);
    } else if (this.searchData?.hotelPrice) {
      // Fallback: usar precio del SearchService si hosting no está disponible
      console.log('💰 precio por noche desde searchData:', this.searchData.hotelPrice);
      this.roomSubtotal = this.numberOfNights * this.searchData.hotelPrice;
      console.log('✅ roomSubtotal calculado desde searchData:', this.roomSubtotal);
    } else {
      console.log('❌ No se puede calcular roomSubtotal - faltan datos');
      this.roomSubtotal = 0;
    }
  }

  // Método para verificar el tamaño de la pantalla
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.checkScreenSize();
  }

  checkScreenSize() {
    this.isSmallScreen = window.innerWidth <= 640; // Pantallas pequeñas (320px - 640px)
  }

  // Funciones para incrementar y decrementar huéspedes
  incrementAdults() {
    this.adults++;
  }

  decrementAdults() {
    if (this.adults > 0) {
      this.adults--;
    }
  }

  incrementChildrenOver2() {
    this.childrenOver2++;
  }

  decrementChildrenOver2() {
    if (this.childrenOver2 > 0) {
      this.childrenOver2--;
    }
  }

  incrementBabiesUnder2() {
    this.babiesUnder2++;
  }

  decrementBabiesUnder2() {
    if (this.babiesUnder2 > 0) {
      this.babiesUnder2--;
    }
  }

  incrementPets() {
    this.pets++;
  }

  decrementPets() {
    if (this.pets > 0) {
      this.pets--;
    }
  }

  // Función para calcular el total de huéspedes
  getTotalGuests(): number {
    return this.adults + this.childrenOver2 + this.babiesUnder2;
  }

  // Función para abrir/cerrar el menú de huéspedes
  toggleGuestMenu() {
    this.isGuestMenuOpen = !this.isGuestMenuOpen;
  }

  // Métodos para compatibilidad con formulario estilo hostinglist
  toggleGuestsDropdown() {
    this.showGuestsDropdown = !this.showGuestsDropdown;
  }

  updateGuests(type: string, change: number) {
    switch (type) {
      case 'adults':
        this.adults = Math.max(1, this.adults + change);
        break;
      case 'children':
        this.childrenOver2 = Math.max(0, this.childrenOver2 + change);
        break;
      case 'babies':
        this.babiesUnder2 = Math.max(0, this.babiesUnder2 + change);
        break;
      case 'pets':
        this.pets = Math.max(0, this.pets + change);
        break;
    }
  }

  getGuestsSummary(): string {
    const parts: string[] = [];

    if (this.adults > 0) {
      parts.push(`${this.adults} adulto${this.adults > 1 ? 's' : ''}`);
    }

    if (this.childrenOver2 > 0) {
      parts.push(`${this.childrenOver2} niño${this.childrenOver2 > 1 ? 's' : ''}`);
    }

    if (this.babiesUnder2 > 0) {
      parts.push(`${this.babiesUnder2} bebé${this.babiesUnder2 > 1 ? 's' : ''}`);
    }

    if (this.pets > 0) {
      parts.push(`${this.pets} mascota${this.pets > 1 ? 's' : ''}`);
    }

    return parts.length > 0 ? parts.join(' · ') : '2 adultos';
  }

  onDateChange() {
    // Sincronizar fechas string con fechas Date
    if (this.checkInDateStr) {
      this.checkInDate = new Date(this.checkInDateStr);
    }
    if (this.checkOutDateStr) {
      this.checkOutDate = new Date(this.checkOutDateStr);
    }
    this.calculateNumberOfNights();
  }

  private async checkAuthentication(silent: boolean = false) {
    try {
      this.isAuthenticated = await this.authService.isAuthenticated();

      if (!this.isAuthenticated) {
        this.resetAuthenticationState();
        return;
      }

      this.accessToken = this.tokenStorage.getAccessToken();
      await this.attemptUserAuthentication(silent);

    } catch (error) {
      this.handleAuthenticationError(error, silent);
    }

    this.backendStatus.lastCheck = new Date();
  }

  private async attemptUserAuthentication(silent: boolean) {
    try {
      this.userId = await this.authService.getUser();
      if (!silent) console.log('✅ Usuario autenticado desde servidor');
      this.backendStatus.authServiceAvailable = true;
    } catch (error) {
      this.handleServerAuthError(error, silent);
    }
  }

  private handleServerAuthError(error: any, silent: boolean) {
    if (!silent) console.warn('⚠️ Error 500 del servidor, usando datos del token como fallback:', error);
    this.backendStatus.authServiceAvailable = false;

    const userFromToken = this.authService.getUserIdFromToken();
    this.userId = userFromToken;

    if (!this.userId) {
      if (!silent) console.error('❌ No se pudo obtener usuario ni del servidor ni del token');
      this.authService.signOut();
      this.isAuthenticated = false;
    }
  }

  private handleAuthenticationError(error: any, silent: boolean) {
    if (!silent) console.error('❌ Error general en autenticación:', error);
    this.resetAuthenticationState();
  }

  private resetAuthenticationState() {
    this.isAuthenticated = false;
    this.userId = null;
    this.accessToken = null;
    this.backendStatus.authServiceAvailable = false;
  }



  async onReserveClick() {
  // Log de depuración para token y userId
  console.log('[RESERVA] accessToken:', this.accessToken);
  console.log('[RESERVA] userId:', this.userId);
  // Log de depuración para token y userId en consulta de reservas
  console.log('[CONSULTA RESERVAS] accessToken:', this.accessToken);
  const user = this.tokenStorage.getUser();
  const userId = user?.id || user?.attributes?.sub;
  console.log('[CONSULTA RESERVAS] userId:', userId);
    // PASO 1: Validaciones básicas de datos del hosting
    if (!this.hosting) {
      alert('Error: No se han cargado los datos del alojamiento.');
      return;
    }

    // PASO 2: Validar fechas
    if (!this.checkInDate || !this.checkOutDate) {
      alert('⚠️ Por favor selecciona las fechas de entrada y salida.');
      return;
    }

    if (this.checkInDate >= this.checkOutDate) {
      alert('⚠️ La fecha de salida debe ser posterior a la fecha de entrada.');
      return;
    }

    // PASO 3: Validar número de huéspedes
    if (this.adults === 0) {
      alert('⚠️ Debe haber al menos un adulto en la reserva.');
      return;
    }

  if (this.getTotalGuests() > Number(this.hosting.ability)) {
      alert(`⚠️ El número total de huéspedes (${this.getTotalGuests()}) excede la capacidad del alojamiento (${this.hosting.ability}).`);
      return;
    }

    // PASO 4: Verificar autenticación SOLO cuando se hace clic en reservar
    console.log('🔐 Verificando autenticación...');
    await this.checkAuthentication();

    if (!this.isAuthenticated) {
      console.log('🔐 Usuario no autenticado, guardando datos y redirigiendo...');
      // Guardar SOLO los datos necesarios en localStorage
      localStorage.setItem('tempReservation', JSON.stringify({
        checkIn: this.checkInDate.toISOString(),
        checkOut: this.checkOutDate.toISOString(),
        adults: this.adults,
        children: this.childrenOver2,
        infants: this.babiesUnder2,
        services: this.selectedServices.map(s => s.id),
        hostingId: this.hosting.id // Guardamos el ID para poder redirigir
      }));

      // Redirigir a login manteniendo el contexto
      this.router.navigate(['/loggin'], {
        queryParams: {
          returnUrl: `/hosting-detail/${this.hosting.id}`
        }
      });
      return;
    }

    // PASO 5: Solo si está autenticado, cargar fechas ocupadas para validar
    console.log('📅 Cargando fechas ocupadas para validar disponibilidad...');
    this.loadOccupiedDates(this.hosting.id, false); // false = mostrar logs

    // PASO 6: Validar que tenemos los datos necesarios
    if (!this.userId || !this.accessToken) {
      alert('❌ Error de autenticación. Por favor inicia sesión nuevamente.');
      this.router.navigate(['/loggin']);
      return;
    }

    console.log('📋 Creando reserva con los siguientes datos:');
    console.log('- Hotel ID:', this.hosting.id);
    console.log('- Check-in:', this.checkInDate);
    console.log('- Check-out:', this.checkOutDate);
    console.log('- Adultos:', this.adults);
    console.log('- Niños:', this.childrenOver2);
    console.log('- Bebés:', this.babiesUnder2);
    console.log('- Servicios adicionales:', this.selectedServices.length);

    // PASO 7: Mostrar advertencia si el servicio de autenticación no está disponible
    if (!this.backendStatus.authServiceAvailable) {
      const proceed = confirm(
        '⚠️ El servidor de autenticación presenta problemas.\n\n' +
        'La reserva podría fallar debido a problemas de conectividad.\n\n' +
        '¿Deseas continuar de todas formas?'
      );

      if (!proceed) {
        return;
      }
    }

    // Obtener userId directamente de TokenStorage antes de crear la reserva
  const userReserva = this.tokenStorage.getUser();
  const userIdReserva = userReserva?.id || userReserva?.attributes?.sub;

  // Debug completo del usuario
  console.log('[DEBUG RESERVA] Contenido completo de tokenStorage.getUser():', JSON.stringify(userReserva, null, 2));
  console.log('[DEBUG RESERVA] userReserva?.id:', userReserva?.id);
  console.log('[DEBUG RESERVA] userReserva?.attributes?.sub:', userReserva?.attributes?.sub);
  console.log('[DEBUG RESERVA] userIdReserva final:', userIdReserva);

  if (!userIdReserva) {
    console.error('[ERROR RESERVA] No se pudo extraer userId de TokenStorage');
    alert('❌ Error: No se pudo identificar el usuario. Por favor inicia sesión nuevamente.');
    this.router.navigate(['/loggin']);
    return;
  }

  const reservationData: ReservationData & { userId: string } = {
      checkInDate: new Date(this.checkInDate).toISOString().split("T")[0],
      checkOutDate: new Date(this.checkOutDate).toISOString().split("T")[0],
      hotelId: this.hosting.id,
      roomId: this.hosting.room?.room_id || '',
      roomCost: Number(this.hosting.room?.price_per_night ?? 0),
      numAdults: this.adults,
      numChildren: this.childrenOver2,
      numInfants: this.babiesUnder2,
      additionalServices: this.selectedServices.map(service => ({
        serviceId: service.id,
        name: service.service,
        cost: service.cost,
        description: service.service // Usando el nombre como descripción por ahora
      })),
  userId: userIdReserva
    };

    // Log para verificar el formato del objeto que se envía
    console.log('🚀 Datos de reserva enviados a /calculations:', JSON.stringify(reservationData, null, 2));

    this.reservationService.createReservation(reservationData, this.accessToken)
      .subscribe({
        next: (response) => this.handleReservationSuccess(response),
        error: (err) => this.handleReservationError(err)
      });
  }

  private handleReservationSuccess(response: any) {
    // Marcar que el servicio de reservas está disponible
    this.backendStatus.reservationServiceAvailable = true;

    if (response?.reservation_id) {
      localStorage.setItem('tempReservationData', JSON.stringify({
        reservationData: response,
        hosting: this.hosting
      }));

      console.log('✅ Reserva creada exitosamente:', response.reservation_id);

      this.router.navigate(['/order-summary', response.reservation_id], {
        state: {
          reservationData: response,
          hosting: this.hosting
        }
      });
    } else {
      console.error('❌ Respuesta del servidor sin reservation_id:', response);
      alert('⚠️ La reserva se procesó pero hubo un problema con la respuesta del servidor. Por favor contacta al soporte.');
    }
  }

  private handleReservationError(error: any) {
    console.error('Error creating reservation:', error);

    // Marcar el estado del servicio según el tipo de error
    if (error.status === 0) {
      this.backendStatus.reservationServiceAvailable = false;
    }

    let errorMessage = '';

    if (error.status === 0) {
      errorMessage = '🌐 Error de conexión con el servicio de reservas:\n\n' +
                    '• El servidor backend no responde\n' +
                    '• Problemas de configuración CORS\n' +
                    '• Red no disponible\n\n' +
                    '📧 Por favor contacta al administrador del sistema.\n' +
                    '📱 También puedes intentar hacer la reserva por teléfono.';
    } else if (error.status === 401) {
      errorMessage = '🔒 Tu sesión ha expirado. Por favor inicia sesión nuevamente.';
      this.authService.signOut();
    } else if (error.status === 403) {
      errorMessage = '🚫 No tienes permisos para realizar esta acción.';
    } else if (error.status === 409) {
      errorMessage = '🚫 No se puede realizar esta reserva porque ya existe una reserva para esta habitación en las fechas seleccionadas.\n\n' +
                    '📅 Por favor selecciona otras fechas o elige una habitación diferente.\n';
    } else if (error.status === 500) {
      errorMessage = '⚠️ Error interno del servidor. Por favor intenta más tarde o contacta al soporte técnico.';
    } else {
      errorMessage = `❌ Error al crear la reserva: ${error.error?.message || 'Error desconocido'}`;
    }

    alert(errorMessage);

    // Si es un error de autenticación, redirigir al login
    if (error.status === 401) {
      this.router.navigate(['/loggin']);
    }
  }


    // Método para abrir/cerrar el modal de reviews
  toggleReviewModal() {
    this.modalOpen = !this.modalOpen;
  }

  // Método para obtener las reseñas visibles
  get visibleReviews() {
    return this.showAllReviews
      ? this.reviews
      : this.reviews.slice(0, this.visibleReviewsLimit);
  }

  // Cargar datos de búsqueda del servicio
  private loadSearchData(): void {
    this.searchData = this.searchService.getSearchData();
    this.hasSearchData = this.searchService.hasValidSearchData();

    if (this.hasSearchData && this.searchData) {
      // Cargar fechas automáticamente
      this.checkInDate = new Date(this.searchData.checkIn);
      this.checkOutDate = new Date(this.searchData.checkOut);

      // Sincronizar fechas string para formulario
      this.checkInDateStr = this.searchData.checkIn;
      this.checkOutDateStr = this.searchData.checkOut;

      // Cargar huéspedes automáticamente
      this.adults = this.searchData.adults;
      this.childrenOver2 = this.searchData.children;
      this.babiesUnder2 = this.searchData.babies;
      this.pets = this.searchData.pets;

      // Calcular número de noches
      this.calculateNumberOfNights();

      // ✅ AGREGAR: Calcular subtotal de habitación
      this.calculateRoomSubtotal();

      console.log('✅ Datos de búsqueda cargados automáticamente:', this.searchData);
    }
  }

}
